/**
 * Linear volume ramp for HTMLMediaElement-like objects ({ volume: number }).
 *
 * Used by the renderer to fade background music out into ad spots and back in
 * after them. Deliberately volume-only: it must NEVER touch currentTime — the
 * `start_at` seek applied at preload is the mid-track resume position and any
 * time manipulation here would break it.
 *
 * The ramp recomputes progress from a wall clock on every tick (instead of
 * accumulating per-tick deltas), so delayed intervals in a busy renderer can
 * only make steps coarser, never make the ramp finish late: at `durationMs`
 * past the start the next tick snaps the volume to the target exactly.
 */
const RAMP_TICK_MS = 50;
const clamp01 = (value) => Math.min(1, Math.max(0, value));
export function rampVolume(el, target, durationMs, now = Date.now) {
    const to = clamp01(target);
    const from = clamp01(el.volume);
    // Zero/negative window (clamped short-window case) or nothing to do:
    // apply the target immediately — a ramp must never delay playback actions.
    if (durationMs <= 0 || from === to) {
        el.volume = to;
        return { cancel: () => undefined };
    }
    const startedAt = now();
    const interval = setInterval(() => {
        const progress = (now() - startedAt) / durationMs;
        if (progress >= 1) {
            el.volume = to;
            clearInterval(interval);
            return;
        }
        el.volume = clamp01(from + (to - from) * progress);
    }, RAMP_TICK_MS);
    return {
        cancel: () => clearInterval(interval),
    };
}
//# sourceMappingURL=rampVolume.js.map